import {post} from './api';

const saveTaskRecord = post('task-record/save');

export {
    saveTaskRecord
};
